import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { LocationSection } from "@/components/LocationSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="relative">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <LocationSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
